<div class="flex flex-col gap-2" *ngIf="mode=='list' && authorized(mainRoles)">
  <div class="flex flex-row flex-wrap gap-2 sm:flex-col">
    <mat-card appearance="outlined" class="w-full sm:w-full m-t-8" [ngClass]="{
      'bg-gray-700': sharedService.userTheme === 'dark',
      'bg-indigo-50': sharedService.userTheme === 'light'}">

      <mat-card-content>
        <div class="flex flex-row justify-center">
          <div>
            <mat-form-field>
              <input matInput placeholder="Search Field" [(ngModel)]="search" (keyup.enter)="searchLabs()" />
              <button *ngIf="search" matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </div>
          <div class="flex flex-row items-center justify-center">
            <div style="padding-right: 10px;">
              <button type="button" mat-flat-button color="primary" (click)="searchLabs()">Search</button>
            </div>
            <div style="padding-right: 10px; padding-left: 10px;">
              <button type="button" *ngIf="authorized(addRoles)" mat-flat-button color="warn" (click)="addLabs()">Add
                Lab</button>
            </div>
            <div class="flex flex-row">
              <mat-radio-group [(ngModel)]="labStatus" style="display:inline-block;">
                <mat-radio-button value="Open" color="primary"> Open </mat-radio-button>
                <mat-radio-button value="Closed" color="primary"> Closed </mat-radio-button>
                <mat-radio-button value="ShowAll" color="primary"> Show All </mat-radio-button>
              </mat-radio-group>
            </div>
          </div>

          <mat-form-field class="flex-1 min-w-[50px]" style="padding-right:20px">
            <mat-label>Select Lab Type</mat-label>
            <mat-select [(value)]="type" (selectionChange)="searchLabs()">
              <mat-option value="None">-- None --</mat-option>
              <mat-option *ngFor="let types of typeList" [value]="types.key">{{types.value}}</mat-option>
            </mat-select>
            <button *ngIf="type" matSuffix mat-icon-button aria-label="Clear" (click)="clearType()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
          <mat-form-field class="flex-1 min-w-[50px]">
            <mat-label>Select Certification Type</mat-label>
            <mat-select [(value)]="cert" (selectionChange)="searchLabs()">
              <mat-option value="None">-- None --</mat-option>
              <mat-option *ngFor="let certs of certList" [value]="certs.key">{{certs.value}}</mat-option>
            </mat-select>
          </mat-form-field>
          <button *ngIf="cert" matSuffix mat-icon-button aria-label="Clear" (click)="clearCert()">
            <mat-icon>close</mat-icon>
          </button>

        </div>
      </mat-card-content>
    </mat-card>
  </div>
  <div class="flex flex-row">
    <mat-card appearance="outlined" class="w-full sm:w-full m-t-8" [ngClass]="{
    'bg-gray-700': sharedService.userTheme === 'dark',
    'bg-indigo-50': sharedService.userTheme === 'light'}">
      <mat-card-content>
        <div class="flex flex-col" *ngIf="labs.length !== 0">
          <div class="flex flex-row">
            <mat-form-field class="w-1/4 filterpad">
              <input matInput id="labsFilter" (keyup)="filterTable($event)" placeholder="Filter"
                value="{{labFilter}}" />

              <button *ngIf="labFilter" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </div>

          <div style="overflow-x:auto">
            <div class="flex flex-row">
              <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort #TableSort="matSort"
                class="mat-elevation-z8 w-full">
                <ng-container matColumnDef="cliaSchedule">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                  <td mat-cell *matCellDef="let labs"><span style="padding-left:10px;">{{labs.cliaSchedule}}</span></td>
                </ng-container>
                <ng-container matColumnDef="stateNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>State #</th>
                  <td mat-cell *matCellDef="let labs" style="padding-right:10px;">{{labs.stateNumber}}</td>
                </ng-container>
                <ng-container matColumnDef="cliaNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Clia Number</th>
                  <td mat-cell *matCellDef="let labs" style="padding-right:10px;">{{labs.cliaNumber}}</td>
                </ng-container>
                <ng-container matColumnDef="labName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Lab Name</th>
                  <td mat-cell *matCellDef="let labs" style="padding-right:10px;"> {{labs.labName}}</td>
                </ng-container>
                <ng-container matColumnDef="outOfState">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>OR</th>
                  <td mat-cell *matCellDef="let labs">{{labs.outOfState}}</td>
                </ng-container>
                <ng-container matColumnDef="covidLab">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Covid</th>
                  <td mat-cell *matCellDef="let labs">{{labs.covidLab}}</td>
                </ng-container>
                <ng-container matColumnDef="labType">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
                  <td mat-cell *matCellDef="let labs" style="padding-right:10px;">{{labs.labType}}</td>
                </ng-container>
                <ng-container matColumnDef="labStatus">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
                  <td mat-cell *matCellDef="let labs">{{labs.labStatus === "Y" ? "Closed": "Open"}} </td>
                </ng-container>
                <ng-container matColumnDef="siteAddress">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Address</th>
                  <td mat-cell *matCellDef="let labs" style="padding-right:10px;">{{labs.siteAddress}}</td>
                </ng-container>
                <ng-container matColumnDef="siteCity">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>City</th>
                  <td mat-cell *matCellDef="let labs">{{labs.siteCity}}</td>
                </ng-container>
                <ng-container matColumnDef="labDirector">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Director</th>
                  <td mat-cell *matCellDef="let labs">{{labs.labDirector}}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="rowclick(row)"></tr>
              </table>
            </div>
          </div>
          <mat-paginator [pageSizeOptions]="getPageSizeOptions()" #TablePaginator="matPaginator" showFirstLastButtons>
          </mat-paginator>
        </div>

      </mat-card-content>

    </mat-card>
  </div>

</div>

<form [formGroup]="newLabGroup">
  <div class="flex flex-row gap-4 w-full" *ngIf="mode=='add'">
    <div class="flex flex-row w-full">
      <mat-card appearance="outlined" class="w-full sm:w-full m-t-8" [ngClass]="{
            'bg-gray-600': sharedService.userTheme === 'dark',
            'bg-indigo-50': sharedService.userTheme === 'light'}">
        <mat-card-content>
          <div class="flex flex-col">
            <h5>Add New Lab</h5>
            <div class="flex flex-col mt-4">

              <mat-form-field>
                <mat-label>Lab Name</mat-label>
                <input matInput formControlName="LabName">
                <mat-error *ngIf="newLabGroup.get('LabName').invalid">
                  This field is required (66 char max)
                </mat-error>
              </mat-form-field>

              <mat-form-field>
                <mat-label>State Number</mat-label>
                <input matInput value="{{newLabGroup.get('StateNumber').value}}" readonly>
              </mat-form-field>

              <mat-form-field>
                <mat-label>CLIA Number</mat-label>
                <input matInput formControlName="CliaNumber">
                <mat-error *ngIf="newLabGroup.get('CliaNumber').invalid">
                  Required. Cannot be longer than 10 characters.
                </mat-error>
              </mat-form-field>

              <mat-form-field>
                <mat-label>Tax ID</mat-label>
                <input matInput formControlName="TaxId">
                <mat-error *ngIf="newLabGroup.get('TaxId').invalid">
                  Required. Cannot be longer than 10 characters.
                </mat-error>
              </mat-form-field>

              <mat-form-field>
                <mat-label>Lab Type</mat-label>
                <mat-select formControlName="LabType">
                  <mat-option value=""></mat-option>
                  <mat-option *ngFor="let types of typeList" [value]="types.key">{{types.value}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="newLabGroup.get('LabType').invalid">
                  Required Field
                </mat-error>
              </mat-form-field>

              <mat-form-field>
                <mat-label>Certificate Type</mat-label>
                <mat-select formControlName="CertificateType">
                  <mat-option value=""></mat-option>
                  <mat-option *ngFor="let types of certList" [value]="types.key">{{types.value}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="newLabGroup.get('CertificateType').invalid">
                  Required Field
                </mat-error>
              </mat-form-field>
            </div>

            <div class="flex flex-row">
              <div>
                <button type="button" mat-raised-button color="primary" (click)="saveNewLab()">Add</button>
              </div>
              <div>
                <button type="button" mat-raised-button (click)="cancel()">Cancel</button>
              </div>

            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</form>

<div class="flex flex-col gap-2" *ngIf="mode=='list' && !authorized(mainRoles)">

  <section *ngIf="authService.loading">
    <h1>Loading...</h1>
    <mat-progress-bar mode="indeterminate" color="warn" aria-label="Loading content">
    </mat-progress-bar>
  </section>
  <section *ngIf="!authService.loading">
    <h1 class="text-2xl font-bold text-center m-t-8">Please contact LQA administrator to assign role(s).</h1>
  </section>
</div>